const AccountStatus = {
  Active: "active",
  Deactivated: "deactivated",
  Pending: "pending",
  Expired: "expired",
  Inactive: "inactive",
};

export default AccountStatus;
